import React from 'react';

export default {
    key: 'salesBackDetail-action',
    build(stub) {
        class SalesBackDetailAction extends React.Component {
            constructor(props) {
                super(props);
                this.state = {};
            }

            onClick = e => {
                e.stopPropagation();
                const { field, sceenKey, module, model, page } = this.props;
                const { formatter: { args: { listKey, filterKey } } } = field;
                page.others.filter = page.data.filter;
                page.others.page = page.data.page;
                page.others.sort = page.data.sort;
                page.data.filter = {};
                page.data.page = {};
                page.data.sort = {};
                stub.ui.helper.addTabPage({
                    component: stub.module[module][sceenKey].salesBackComponentDetail,
                    listKey: listKey,
                    filterKey: filterKey,
                    title: '回款详情',
                    model: model,
                    listPageData: page
                })
            };

            render() {
                const { field: { label } } = this.props;
                return(<a href="javascript:" onClick={this.onClick}>{stub.filter.transform(label)}</a>)
            }
        }

        return SalesBackDetailAction;
    }
}
